<p-confirmDialog appendTo="body" header="Confirmation" icon="pi pi-exclamation-triangle" [closable]="false" [baseZIndex]="15000"></p-confirmDialog>
<p-panel header="Import File" toggleable="true">
    <ng-template pTemplate="icons">
      <p-button id="buttonStyle" data-toggle="tooltip" data-placement="top" title="Click to Import via file or GEID" (onClick)="menu.toggle($event)" >Add GE</p-button>  
      <p-menu #menu [model]="items" [popup]="true">
        <ng-template pTemplate="item" let-item>
          <a pRipple class="flex align-items-center p-menuitem-link" data-toggle="tooltip" data-placement="top" [title]="item.label === 'By GEID/Name' ? 'Paste GeIds from excel column or comma separated list' : 'GEID/Name, Program, Year and PStage columns are required in excel'">
              <span [class]="item.icon"></span>
              <span class="ml-2">{{ item.label }}</span>
          </a>
      </ng-template>
      </p-menu>
      <input id="importFile" type="file" style="display:none" (change)="handle($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
      <p-button id="buttonStyle" data-toggle="tooltip" data-placement="top" title="Export a template that has all columns that can be used in import and will be auto mapped." (click)="exportTemplate()" >Export Template</p-button>   
      <span data-toggle="tooltip" data-placement="top" [title]="displayGrid ? 'Reset Screen' : 'No pending changes to reset'">
        <p-button id="buttonStyle" [disabled]="!displayGrid" (click)="reset()" >Reset</p-button>
      </span>
      <span data-toggle="tooltip" data-placement="top" [title]="submitDisabled ? 'Required data must be provided' : 'Submit mapped data. After success message, you can view submitted data in precode screen.'">
        <p-button id="buttonStyle" (click)="submit()" [disabled]="submitDisabled">Submit</p-button> 
      </span>
    </ng-template>
    <div class="grid">
      <label for="crop" style="margin-top: 6px;">Crop*: </label>
      <p-dropdown [options]="crops" [style]="{'margin-left': '10px', 'width': '140px'}" placeholder="Select" [(ngModel)]="selectedCrop" (onChange)="refreshPage()" optionLabel="Name" inputId="crop"></p-dropdown>    
      <p-checkbox *ngIf="displayGrid" [(ngModel)]="appendComments" label="Append Comments" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top" 
      title="Append or Replace Comments" [style]="{'margin-left': '30px'}" />
      <p-checkbox *ngIf="displayGrid" [(ngModel)]="appendMetadata" label="Append Metadata" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top" 
      title="Append or Replace Metadata" [style]="{'margin-left': '10px'}" />
      <p-checkbox *ngIf="displayGrid" [(ngModel)]="appendTags" label="Append Tags" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top"
      title="Append or Replace Tags" [style]="{'margin-left': '10px'}" />
      <p-checkbox *ngIf="displayGrid && showCreateTags" [(ngModel)]="createNewTags" label="Create New Tags" [binary]="true" inputId="binary" data-toggle="tooltip" (onChange)="toggleTags($event)"
      data-placement="top" title="Save new tags to preference" [style]="{'margin-left': '20px'}" />
    </div>
    <div>
      <ag-grid-angular *ngIf="displayGrid"
        style="height: 55vh; margin-left: -12px; margin-right: -11px; margin-bottom: -8px;" 
        class="ag-theme-balham"
        [rowData]="rowData" 
        [columnDefs]="valDataColDef"
        [defaultColDef]="defaultColDef" 
        [pagination]="true"
        rowSelection="multiple"
        [enableBrowserTooltips]="true"
        [paginationPageSize]="50"
        [gridOptions]="gridOptions"
        (cellKeyDown)="onCellKeyDown($event)"
        (gridReady)="onGridReady($event)">
      </ag-grid-angular>
      <p-dialog [contentStyle]="{'overflow':'visible'}"  [(visible)]="openImportedData" [modal]="true"
      [style]="{width: '1200px', height:'400px'}" [baseZIndex]="10000" [dismissableMask]="false" [closeOnEscape]="false" [draggable]="false" appendTo="body">
      <p-header class="grid nested-grid" style="width: 1150px; height: 30px;">
        <div class="col-2">
          <label style="margin-top: 7px; font-size: 18px;">Map Headers </label>
        </div>
        <div class="col" style="margin-top: -15px;">
          <div class="grid">
            <label style="margin-right: 20px; margin-left: 5%;margin-top: 7px;"><b>Total Columns:</b>
            {{importColumnDefs.length}}</label>
            <label style="margin-right: 20px; margin-top: 7px;"><b>Total Mapped Columns:</b> {{mappedColCount}}</label>
            <label style="margin-right: 20px; margin-top: 7px;"><b>Total Unmapped Columns:</b>
              {{importColumnDefs.length - mappedColCount}}</label>
            <button pButton type="button"
              style="margin-left: 20px; margin-right: 20px; border-radius: 20px; width: 20px; height: 20px;top: 7px !important;" icon="pi pi-info"
              data-toggle="tooltip" data-placement="top" [title]="tooltipText" (click)="showInfoToolTip = true"
              [style.backgroundColor]="this.tooltipText !== 'All required columns mapped.' ? 'red' : '#2399e5'"></button>
            <p-overlay [(visible)]="showInfoToolTip" appendTo="body" [responsive]="{ direction: 'bottom'}" contentStyleClass="bg-surface-0 dark:bg-surface-900 shadow">
              <div style="background-color: black; border-style: solid; border-width: 1px; border-color: darkgray;">
                <label style="color: lightgray; margin: 3px; margin-left: 5px; font-size: 12px;"><b>{{tooltipText}}</b></label>
              </div>
            </p-overlay>
          </div>
          <p-checkbox class="col" [(ngModel)]="onlyTags" label="Only Tags/Metadata/Comments" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top" 
          title="Check if only updating tags, metadata or comments" [style]="{'margin-left': '200px'}" />
        </div>
        <div class="col-2" style="margin-top: -5px;">
          <button pButton type="button" [disabled]="this.tooltipText !== 'All required columns mapped.'" style="margin-right: 20px; min-width: 40px;"
          (click)="onValidate()">Ok</button>
          <button style="min-width: 60px;" pButton type="button" (click)="openImportedData = false">Cancel</button>
        </div>
      </p-header>
      <p-table *ngIf="showImportGrid" [columns]="importColumnDefs" [value]="gridImportData" [scrollable]="true"
        scrollHeight="350px" class="minHeightGrid">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of importColumnDefs" style="min-width: 14.5em;width: 14.5em;">
              {{col.header}}
              <select *ngIf="!onlyTags || (onlyTags && col.mappedCol && !col.mappedCol.includes('_'))" [ngModel]="col.mappedCol"
                (change)="onHeaderSelectionChange($event.target, col)">
                <option *ngFor="let val of headerCols" [ngValue]="val">{{val}}</option>
              </select>
              <select *ngIf="onlyTags && col.mappedCol && col.mappedCol.includes('_')">
                <option>{{col.mappedCol.split('_')[1]}}</option>
              </select>
            </th>
          </tr>         
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>           
            <td data-toggle="tooltip" data-placement="top" title="{{rowData[col.header]}}" *ngFor="let col of columns"
              style="width: 14.5em;min-width: 14.5em;  white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
              {{rowData[col.header]}}
            </td>
          </tr>
        </ng-template>
      </p-table>
      </p-dialog>
      <p-dialog [(visible)]="showConfirmSheet" [draggable]="false" header="Select a Sheet"
        [style]="{width: '300px', height:'300px'}" [baseZIndex]="10000" [modal]="true" [dismissableMask]="false" appendTo="body">
        <p-listbox *ngIf="sheets && sheets.length > 0" [options]="sheets" (onChange)="onSheetChange($event)" 
          [style]="{'width':'15rem'}" optionLabel="name" [listStyle]="{'max-height': '200px'}"></p-listbox>
      </p-dialog>
    </div>
    <p-dialog [(visible)]="openImportByGes" [modal]="true" (visibleChange)="resetGeImportScreen()"
      [style]="{width: '1650px', height:'700px'}" [baseZIndex]="10000" [dismissableMask]="false" [closeOnEscape]="false" [draggable]="false" appendTo="body">
      <ng-template pTemplate="header">
        <span style="width:100%"> 
        <div  style="display: flex;justify-content: space-between;">
          <div>
            <label style="font-weight: bold;font-size: 17px;">Import by GEID(s)</label>
          </div>
          <div>
            <button style="width: fit-content; " pButton type="button" [disabled]="!(selectedGECrop && selectedYear && idList.length > 0)" (click)="getDataByGes()">Add</button>
            <button style="width: fit-content; margin-left: 10px;" pButton type="button" [disabled]="!(selectedGECrop || selectedYear || idList.length > 0)" (click)="resetGeImportScreen()">Reset</button>
            <button style="width: fit-content; margin-left: 10px;" pButton type="button" [disabled]="!(selectedGeIdsData.length > 0 && saveEnabledForGes) " (click)="submitFetchedProgramsByGes()">Submit</button>
          </div>
        </div>      
        </span>
      </ng-template>
      <div class="row">
        <div class="col-3" style="margin-left: 10px;width: 22%;">
          <p-floatLabel style="margin-left: 20px;">
            <p-dropdown [options]="crops" [(ngModel)]="selectedGECrop" [filter]="true" optionLabel="Name" (onChange)="onGeCropChange()" filterMatchMode="startsWith"
              placeholder="Select" />
            <label style="font-size: large;">Crop </label>
          </p-floatLabel>
          <p-floatLabel style="margin-left: 20px;">
            <p-dropdown [options]="years" [(ngModel)]="selectedYear" [filter]="true" placeholder="Select" (onChange)="onYearChange()" filterMatchMode="startsWith" />
            <label style="font-size: large;">Year </label>
          </p-floatLabel>
          <div style="display: block;margin-top: 15px;">
            <label style="font-weight: bold;font-size: large;vertical-align: middle; margin-right: 5px;"> Search By:</label>
            <p-radioButton value="GE NAME" [(ngModel)]="searchByGeIdName" label="GE_NAME" />
            <p-radioButton value="GE ID" label="GEID" [style]="{'margin-left': '5px'}" [(ngModel)]="searchByGeIdName" />
            <label style="font-weight: bold; display: block; margin-bottom: 12px;margin-top: 5px;">Total Rows :
                {{idList.length}}</label>
            <span>
                <textarea style="max-height: 244px;" [rows]="10" [cols]="20" [autoResize]="false" [(ngModel)]="idListText" pInputTextarea></textarea>
            </span>
        </div>
          <label style="font-weight: bold; display: block; margin-bottom: 12px;margin-top: 9px;">Invalid GE(S)</label>
          <span>
            <textarea pInputTextarea style="max-height: 244px;" [rows]="10" [cols]="20" [(ngModel)]="invalidIdListText"></textarea>
          </span>
        </div>
        <div *ngIf="selectedGeIdsData.length > 0" class="col-9" style="margin-left: 10px;">
          <div class="grid">
            <p-checkbox *ngIf="!displayGrid" [(ngModel)]="appendComments" label="Append Comments" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top" 
            title="Append or Replace Comments" [style]="{'margin-left': '30px'}" />
            <p-checkbox *ngIf="!displayGrid" [(ngModel)]="appendMetadata" label="Append Metadata" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top" 
            title="Append or Replace Metadata" [style]="{'margin-left': '10px'}" />
            <p-checkbox *ngIf="!displayGrid" [(ngModel)]="appendTags" label="Append Tags" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top"
            title="Append or Replace Tags" [style]="{'margin-left': '10px'}" />
            <p-checkbox *ngIf="!displayGrid" [(ngModel)]="onlyTags" label="Only Tags/Metadata/Comments" [binary]="true" inputId="binary" data-toggle="tooltip" data-placement="top" 
            title="Check if only updating tags, metadata or comments" [style]="{'margin-left': '10px'}" (onChange)="refreshStageCol($event)" />
          </div>
          <ag-grid-angular #geGrid
          style="height: 65vh; margin-left: -12px; margin-right: -11px; margin-bottom: -8px; margin-top: 5px;" 
          class="ag-theme-balham"
          [rowData]="selectedGeIdsData" 
          [columnDefs]="geIdColDef"          
          [enableRangeSelection]="true"
          [undoRedoCellEditing]="true"
          [getContextMenuItems]="getContextMenuItems"
          [defaultColDef]="defaultColDef" 
          rowSelection="multiple"
          [components]="components"
          [enableBrowserTooltips]="true"
          [stopEditingWhenCellsLoseFocus]="true"
          [gridOptions]="geGridOptions"
          (gridReady)="onGEGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </p-dialog>
    <p-dialog [(visible)]="showFindReplace" [draggable]="false" header="Find/Replace" [baseZIndex]="10000" [modal]="false" [dismissableMask]="false" appendTo="body" [position]="'topright'" styleClass="headerPanelSmall">
      <div class="grid" style="margin: 10px; margin-top: 2px;">
        <label style="width: 120px; margin-top: 5px;">Find what</label>
        <input type="text" pInputText [(ngModel)]="findText" style="margin-left: 5px; margin-right: 25px;" />
        <span data-toggle="tooltip" data-placement="top" title="Find Next">
          <p-button id="buttonStyle" [disabled]="!findText" (onClick)="find(true)" [style]="{width: '97px', display: 'block', padding: '7px'}"> Find Next</p-button>
        </span>
      </div>
      <div class="grid" style="margin: 10px;">
        <label style="width: 120px; margin-top: 5px;">Replace With</label>
        <input type="text" pInputText [(ngModel)]="replaceText" style="margin-left: 5px; margin-right: 25px;"/>
        <span data-toggle="tooltip" data-placement="top" title="Find next match">
          <p-button id="buttonStyle" [disabled]="!findText" (onClick)="replace(false)" [style]="{width: '97px', display: 'block', padding: '7px'}"> Replace</p-button>
        </span>
      </div>
      <div class="grid" style="margin: 10px;">
        <div style="margin-top: 5px;">
            <p-checkbox [(ngModel)]="matchCaseChecked" label="Match case" (onChange)="foundCell=[]" [binary]="true" inputId="binary" />
        </div>
        <div style="margin-left: 50px; margin-right: 60px; margin-top: 5px; margin-bottom: 2px;">
            <p-checkbox [(ngModel)]="matchWordChecked" label="Match Word" (onChange)="foundCell=[]" [binary]="true" inputId="binary" />
        </div>
        <span data-toggle="tooltip" data-placement="top" title="Replace All">
          <p-button id="buttonStyle" [disabled]="!findText" (onClick)="replace(true)" [style]="{padding: '7px'}"> Replace All</p-button>
        </span>
      </div>
  </p-dialog>
</p-panel>